import { render, staticRenderFns } from "./verificationCode.vue?vue&type=template&id=bdc2081c&scoped=true&"
import script from "./verificationCode.vue?vue&type=script&lang=js&"
export * from "./verificationCode.vue?vue&type=script&lang=js&"
import style0 from "./verificationCode.vue?vue&type=style&index=0&id=bdc2081c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc2081c",
  null
  
)

export default component.exports